<template>
  <div>
    <el-button
      plain
      @click="alertDialog"
    >
      导出EXCEL
    </el-button>
    <el-dialog
      title="选择导出类型"
      append-to-body
      v-loading="downloadLoading"
      :visible.sync="dialogVisible"
      width="300px"
      :before-close="handleClose"
      :show-close="true"
      center
    >
      <el-button
        type="primary"
        @click="exportJson(1)"
        round
      >
        导出当前页
      </el-button>
      <el-button
        type="success"
        @click="exportJson(0)"
        round
      >
        导出所有
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
	export default {
		name: 'ExportExcel',
		data() {
			return {
				downloadLoading: false,
				dialogVisible: false
			}
		},
		props: {
			tHeader: Array,
			filterVal: Array,
			list: Array,
			name: String
		},
		mounted() {},
		watch: {},
		created() {},
		methods: {
			alertDialog() {
				this.dialogVisible = true
			},
			exportTable() {
				this.downloadLoading = true
				require.ensure([], () => {
					const {
						export_table_to_excel1
					} = require('@/util/Export2Excel');
					if(!this.tHeader) {
						this.downloadLoading = false
						this.open("导出", "导出异常useException")
						return
					}
					if(!this.filterVal) {
						this.downloadLoading = false
						this.open("导出", "导出异常useException")
						return
					}
					if(!this.list) {
						this.downloadLoading = false
						this.open("导出", "导出异常useException")
						return
					}
					if(!this.id) {
						this.downloadLoading = false
						this.open("导出", "导出异常useException")
						return
					}
					export_table_to_excel1(this.id, this.name)
					this.downloadLoading = false
				})
			},
			exportJson(myKey) {
				this.downloadLoading = true
				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require('@/util/Export2Excel');　
					if(!this.tHeader) {
						this.downloadLoading = false
						this.open("导出", "导出异常useException")
						return
					}
					if(!this.filterVal) {
						this.downloadLoading = false
						this.open("导出", "导出异常useException")
						return
					}
					var list = this.list
					const tHeader = this.tHeader
					const filterVal = this.filterVal
					var _this=this
					if(myKey == 0) {
						this.$emit("getValue", 0, function(str) {
							list = str;
							const data = _this.formatJson(filterVal, list)
							export_json_to_excel(tHeader, data, _this.name)
							_this.downloadLoading = false
							console.log(data,"data")
							return false
						})
					} else {
						this.$emit("getValue", 1, function(str) {
							list = str;
							const data = _this.formatJson(filterVal, list)
							export_json_to_excel(tHeader, data, _this.name)
							_this.downloadLoading = false
						})
					}
				})
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			open(title, message) {
				this.$alert(message, title, {
					confirmButtonText: '确定'
				});
			},
			handleClose(done) {
				done();
			},
		},
		computed: {}
	}
</script>

<style scoped>

</style>